<template>
    <div>
        <b-dropdown :disabled="isDataSending" variant="custom-green" right text="Выгрузки" v-if="orgRoleIsPermitted($orgRoles.CUSTOMER_FL44)">
            <b-dropdown-item :disabled="isDataSending" link-class="grey-color fs-14" @click="showContractsExportModal = true">Реестр контрактов</b-dropdown-item>
            <b-dropdown-item :disabled="isDataSending" link-class="grey-color fs-14" @click="downloadPostReport">Пост-отчет по закупкам малого объёма</b-dropdown-item>
            <b-dropdown-item :disabled="isDataSending" link-class="grey-color fs-14" @click="showDeliverablesByYearExportModal = true">Реестр закупленных ТРУ за год</b-dropdown-item>
        </b-dropdown>

        <b-button v-else :disabled="isDataSending" class="text-uppercase" style="height: 32px; line-height: 15px" variant="custom-green" @click="showContractsExportModal = true">Реестр контрактов</b-button>

        <b-modal v-model="showContractsExportModal" centered hide-header-close no-close-on-backdrop no-close-on-esc title="Реестр контрактов" size="lg">
            <form-row-edit-date label="Дата заключения контракта, С" :label-cols-sm="6" :label-cols-lg="6" v-model="exportContractsRequest.fromContractDate" :max-date="exportContractsRequest.toContractDate" />
            <form-row-edit-date label="Дата заключения контракта, По (включительно)" :label-cols-sm="6" :label-cols-lg="6" v-model="exportContractsRequest.toContractDate" :min-date="exportContractsRequest.fromContractDate" />
            <form-row-select-multiple label="Типы закупок" :options="$globalDictionaries.orderTypes" label-field="title" v-model="exportContractsRequest.orderType" />
            <form-row-edit-radio label="Типы контрактов" v-model="exportContractsRequest.type" :options="radioOptions" stacked />

            <div slot="modal-footer" class="w-100 text-right">
                <b-overlay :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button class="text-uppercase mr-2" variant="custom-outline-secondary" @click="handleContractsExportCancel">Отмена</b-button>
                </b-overlay>
                <b-overlay :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button class="text-uppercase" variant="custom-green" @click="handleContractsExportAccept">Выгрузить</b-button>
                </b-overlay>
            </div>
        </b-modal>
        <b-modal v-model="showDeliverablesByYearExportModal" centered hide-header-close no-close-on-backdrop no-close-on-esc title="Реестр закупленных ТРУ за год" size="lg">
            <form-row-single-select label="Год формирования выгрузки" :label-cols-sm="6" :label-cols-lg="6" v-model="exportDeliverablesByYearRequest.year" :options="getYears()" label-field="year" track-by="year" />

            <div slot="modal-footer" class="w-100 text-right">
                <b-overlay :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button class="text-uppercase mr-2" variant="custom-outline-secondary" @click="handleDeliverablesByYearCancel">Отмена</b-button>
                </b-overlay>
                <b-overlay :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button class="text-uppercase" variant="custom-green" @click="handleDeliverablesByYearAccept">Выгрузить</b-button>
                </b-overlay>
            </div>
        </b-modal>
    </div>
</template>

<script>
import FileDownload from 'js-file-download';
import FormRowEditRadio from '@/components/common/form-rows/form-row-edit-radio.vue';
import FormRowSelectMultiple from '@/components/common/form-rows/form-row-select-multiple.vue';

export default {
    name: 'cabinet-fl44-contracts-export-button',
    components: { FormRowSelectMultiple, FormRowEditRadio },
    data() {
        return {
            showContractsExportModal: false,
            showDeliverablesByYearExportModal: false,
            exportContractsRequest: {
                fromContractDate: null,
                toContractDate: null,
                type: '',
                orderType: []
            },
            exportDeliverablesByYearRequest: {
                year: new Date().getFullYear()
            },
            isDataSending: false,
            radioOptions: [
                { text: 'Все', value: '' },
                { text: 'Контракты', value: 'fl44' },
                { text: 'Внесистемные закупки', value: 'fl44_external' }
            ]
        };
    },
    methods: {
        getYears() {
            const years = [];
            for (let year = 2021; year <= new Date().getFullYear(); year++) {
                years.push({ year: year });
            }
            return years;
        },
        downloadPostReport() {
            this.isDataSending = true;
            this.$api.personal.fl44
                .getPostReportXlsExport()
                .then((response) => {
                    FileDownload(response.data, 'Пост-отчет.xlsx');
                })
                .finally(() => {
                    this.isDataSending = false;
                });
        },
        getFilters(request) {
            const filterValues = [];
            for (const [key, value] of Object.entries(request)) {
                if (value) {
                    filterValues[key] = value;
                }
            }
            return { ...filterValues };
        },
        handleContractsExportAccept() {
            this.isDataSending = true;
            this.$api.personal.fl44
                .getContractsXlsExport(this.getFilters(this.exportContractsRequest))
                .then((response) => {
                    FileDownload(response.data, 'Контракты.xlsx');
                })
                .finally(() => {
                    this.handleContractsExportCancel();
                });
        },
        handleContractsExportCancel() {
            this.showContractsExportModal = false;
            this.exportContractsRequest.fromContractDate = null;
            this.exportContractsRequest.toContractDate = null;
            this.exportContractsRequest.type = '';
            this.exportContractsRequest.orderType = [];
            this.isDataSending = false;
        },
        handleDeliverablesByYearAccept() {
            this.isDataSending = true;
            this.$api.personal.fl44
                .getDeliverablesByYearXlsExport(this.getFilters(this.exportDeliverablesByYearRequest))
                .then((response) => {
                    FileDownload(response.data, `ТРУ за ${this.exportDeliverablesByYearRequest.year}.xlsx`);
                })
                .finally(() => {
                    this.handleDeliverablesByYearCancel();
                });
        },
        handleDeliverablesByYearCancel() {
            this.showDeliverablesByYearExportModal = false;
            this.exportDeliverablesByYearRequest.year = new Date().getFullYear();
            this.isDataSending = false;
        }
    }
};
</script>
